
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getAllVHNDData } from '../services/authService';
import '.././styles/VHNDParticipation.css';
import { useNavigate } from 'react-router-dom';
import Loader from '../components/Loader';
const VHNDParticipation = () => {
  const [vhndData, setVhndData] = useState(null);
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [selectedBeneficiaries, setSelectedBeneficiaries] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filter, setFilter] = useState('All');
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [pendingSync, setPendingSync] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
   const [loading, setLoading] = useState(true);
  // Fetch VHND data from API
  useEffect(() => {
     setLoading(true);
    const fetchVhndData = async () => {
      try {
        const response = await getAllVHNDData(1,10);
        const data = response.data.data[0]; // Assuming we use the first VHND record
        setVhndData(data);
        // Map beneficiaries from VhndParticipations
        const beneficiaryList = data.VhndParticipations.map((participation) => ({
          id: participation.beneficiary_id,
          name: `Beneficiary ${participation.beneficiary_id}`, // Placeholder: Fetch real names from beneficiary table
          status: 'Absent',
          category: participation.beneficiary_id % 3 === 0 ? 'Pregnant' : participation.beneficiary_id % 3 === 1 ? 'Child' : 'Elderly', // Placeholder
          services: participation.VhndParticipantServices.map((service) => ({
            id: service.id,
            type: service.service_type,
            details: service.service_details,
            completed: false,
            notes: service.outcome || '',
          })),
        }));
            setLoading(false);
        setBeneficiaries(beneficiaryList);
      } catch (error) {
        console.error('Error fetching VHND data:', error);
        setIsOffline(true);
        // Load from localStorage if offline
        const cachedData = localStorage.getItem('vhndData');
            setLoading(false);
              setError(error.message);
        if (cachedData) {
          setVhndData(JSON.parse(cachedData));
          setBeneficiaries(JSON.parse(localStorage.getItem('beneficiaries') || '[]'));
        }
      }
    };

    fetchVhndData();

    // Handle online/offline events
    const handleOnline = () => {
      setIsOffline(false);
      syncPendingChanges();
    };
    const handleOffline = () => setIsOffline(true);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);


    const vhndaplan = async () => {
  navigate('/VHND-create');

  }


  // Sync pending changes when online
  const syncPendingChanges = async () => {
    const pending = JSON.parse(localStorage.getItem('pendingSync') || '[]');
    for (const change of pending) {
      try {
        await axios.post('https://ashaapi.bluai.ai/api/asha/updateVHNDParticipation', change);
        setPendingSync((prev) => prev.filter((item) => item !== change));
      } catch (error) {
        console.error('Error syncing data:', error);
      }
    }
    localStorage.setItem('pendingSync', JSON.stringify(pendingSync));
  };

  // Handle beneficiary selection
  const handleSelectBeneficiary = (id) => {
    setSelectedBeneficiaries((prev) =>
      prev.includes(id) ? prev.filter((bid) => bid !== id) : [...prev, id]
    );
  };

  // Handle marking attendance
  const handleMarkAttendance = (status) => {
    const updatedBeneficiaries = beneficiaries.map((b) =>
      selectedBeneficiaries.includes(b.id) ? { ...b, status } : b
    );
    setBeneficiaries(updatedBeneficiaries);
    saveChanges(updatedBeneficiaries);
  };

  // Handle service completion
  const handleServiceChange = (beneficiaryId, serviceId, field, value) => {
    const updatedBeneficiaries = beneficiaries.map((b) =>
      b.id === beneficiaryId
        ? {
            ...b,
            services: b.services.map((s) =>
              s.id === serviceId ? { ...s, [field]: value } : s
            ),
          }
        : b
    );
    setBeneficiaries(updatedBeneficiaries);
    saveChanges(updatedBeneficiaries);
  };

  // Save changes to localStorage or API
  const saveChanges = (updatedBeneficiaries) => {
    if (isOffline) {
      localStorage.setItem('beneficiaries', JSON.stringify(updatedBeneficiaries));
      setPendingSync((prev) => [...prev, updatedBeneficiaries]);
      localStorage.setItem('pendingSync', JSON.stringify(pendingSync));

    } else {
      console.log('updatedBeneficiaries', updatedBeneficiaries);
      axios
        .post('https://ashaapi.bluai.ai/api/asha/updateVHNDParticipation', {
          vhnd_id: vhndData?.vhnd_id,
          participations: updatedBeneficiaries.map((b) => ({
            beneficiary_id: b.id,
            status: b.status,
            services: b.services,
          })),
        })
        .catch((error) => {
          console.error('Error saving data:', error);
          setIsOffline(true);
          localStorage.setItem('beneficiaries', JSON.stringify(updatedBeneficiaries));
          setPendingSync((prev) => [...prev, updatedBeneficiaries]);
          localStorage.setItem('pendingSync', JSON.stringify(pendingSync));
        });
    }
  };

  // Filter beneficiaries
  const filteredBeneficiaries = beneficiaries.filter((b) => {
    const matchesSearch = b.name.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesFilter =
      filter === 'All' ||
      (filter === 'Present' && b.status === 'Present') ||
      (filter === 'Absent' && b.status === 'Absent') ||
      (filter === b.category) ||
      (filter === 'Services Completed' && b.services.every((s) => s.completed)) ||
      (filter === 'Follow-up Required' && b.services.some((s) => s.notes.includes('follow-up')));
    return matchesSearch && matchesFilter;
  });

 if (loading) return <Loader />;
  if (error) return <div className="error">{error}</div>;

  return (
    <>
      <div className="page-header flex items-center mb-4">
        <button className="back-button mr-4 p-2 rounded-full bg-gray-200 hover:bg-gray-300">
          <span className="material-icons">arrow_back</span>
        </button>
        <div className="page-title text-2xl font-bold">VHND Participation Record</div>
      </div>

      {isOffline && (
        <div className="offline-banner flex items-center bg-yellow-100 text-yellow-800 p-3 mb-4 rounded">
          <span className="material-icons mr-2">wifi_off</span>
          You are working offline. Your changes will sync when you're back online.
        </div>
      )}

      <div className="form-card bg-white shadow-md rounded-lg p-6">
    
            <div className="tab-container">
          <div className="tab" onClick={vhndaplan}>Plan VHND</div>
          <div className="tab active">Record Participation</div>

        </div>

        <div className="form-section mb-6">
          <div className="village-card bg-gray-50 p-4 rounded-lg mb-4">
            <div className="village-header flex justify-between items-center">
              <div className="village-name text-xl font-semibold">Rampur Village</div>
              <div className="date-display flex items-center">
                <span className="material-icons mr-1">event</span>
                {new Date(vhndData.vhnd_date).toLocaleDateString()}
              </div>
            </div>
            <div className="village-details text-gray-600">Location: {vhndData.location}</div>
            <div className="village-details text-gray-600">Focus: {vhndData.services_provided}</div>
          </div>

          <div className="stats-row flex space-x-4">
            <div className="stat-card bg-white shadow-sm p-4 rounded-lg flex-1">
              <div className="stat-value text-2xl font-bold">
                {beneficiaries.filter((b) => b.status === 'Present').length}/{vhndData.expected_beneficiaries}
              </div>
              <div className="stat-label text-gray-600">Attendance</div>
              <div className="progress-container mt-2">
                <div className="progress-bar bg-gray-200 h-2 rounded-full">
                  <div
                    className="progress-fill bg-blue-600 h-2 rounded-full"
                    style={{
                      width: `${
                        (beneficiaries.filter((b) => b.status === 'Present').length /
                          vhndData.expected_beneficiaries) *
                        100
                      }%`,
                    }}
                  ></div>
                </div>
              </div>
            </div>
            <div className="stat-card bg-white shadow-sm p-4 rounded-lg flex-1">
              <div className="stat-value text-2xl font-bold">
                {beneficiaries.reduce((sum, b) => sum + b.services.filter((s) => s.completed).length, 0)}
              </div>
              <div className="stat-label text-gray-600">Services Provided</div>
            </div>
            <div className="stat-card bg-white shadow-sm p-4 rounded-lg flex-1">
              <div className="stat-value text-2xl font-bold">
                {beneficiaries.filter((b) => b.services.some((s) => s.notes.includes('follow-up'))).length}
              </div>
              <div className="stat-label text-gray-600">Follow-ups Needed</div>
            </div>
          </div>
        </div>

        <div className="form-section mb-6">
          <div className="section-title text-lg font-semibold mb-4">Attendance & Services</div>

          <div className="attendance-summary bg-gray-50 p-4 rounded-lg mb-4">
            <div className="summary-header mb-2">
              <div className="summary-title font-semibold">Attendance Summary</div>
            </div>
            <div className="attendance-row flex justify-between py-1">
              <div className="attendance-label">Pregnant Women:</div>
              <div className="attendance-value">
                {beneficiaries.filter((b) => b.category === 'Pregnant' && b.status === 'Present').length}/
                {beneficiaries.filter((b) => b.category === 'Pregnant').length}
              </div>
            </div>
            <div className="attendance-row flex justify-between py-1">
              <div className="attendance-label">Children:</div>
              <div className="attendance-value">
                {beneficiaries.filter((b) => b.category === 'Child' && b.status === 'Present').length}/
                {beneficiaries.filter((b) => b.category === 'Child').length}
              </div>
            </div>
            <div className="attendance-row flex justify-between py-1">
              <div className="attendance-label">Elderly:</div>
              <div className="attendance-value">
                {beneficiaries.filter((b) => b.category === 'Elderly' && b.status === 'Present').length}/
                {beneficiaries.filter((b) => b.category === 'Elderly').length}
              </div>
            </div>
          </div>

          <div className="bulk-action-bar flex items-center justify-between bg-gray-100 p-3 rounded-lg mb-4">
            <div className="bulk-action-text">
              <strong>{selectedBeneficiaries.length} beneficiaries</strong> selected
            </div>
            <div className="flex space-x-2">
              <button
                className="service-button flex items-center bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700"
                onClick={() => handleMarkAttendance('Present')}
              >
                <span className="material-icons mr-1">check</span>
                Mark Present
              </button>
              <button
                className="service-button flex items-center bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                onClick={() => handleMarkAttendance('Absent')}
              >
                <span className="material-icons mr-1">clear</span>
                Mark Absent
              </button>
            </div>
          </div>

          <div className="search-bar flex items-center mb-4">
            <input
              type="text"
              className="input-field flex-1 border rounded-l px-3 py-2"
              placeholder="Search beneficiaries..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button className="search-button bg-blue-600 text-white px-3 py-2 rounded-r hover:bg-blue-700">
              <span className="material-icons">search</span>
            </button>
          </div>

          <div className="filter-bar flex flex-wrap gap-2 mb-4">
            {[
              'All',
              'Present',
              'Absent',
              'Pregnant Women',
              'Children',
              'Elderly',
              'Services Completed',
              'Follow-up Required',
            ].map((f) => (
              <div
                key={f}
                className={`chip px-3 py-1 rounded-full cursor-pointer ${
                  filter === f ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'
                }`}
                onClick={() => setFilter(f)}
              >
                {f}
              </div>
            ))}
          </div>

          <div className="beneficiary-list space-y-4">
            {filteredBeneficiaries.map((beneficiary) => (
              <div key={beneficiary.id} className="beneficiary-item bg-gray-50 p-4 rounded-lg">
                <div className="beneficiary-header flex justify-between items-center mb-2">
                  <div className="beneficiary-name flex items-center">
                    <input
                      type="checkbox"
                      className="mr-2"
                      checked={selectedBeneficiaries.includes(beneficiary.id)}
                      onChange={() => handleSelectBeneficiary(beneficiary.id)}
                    />
                    {beneficiary.name}
                    <span
                      className={`beneficiary-badge px-2 py-1 rounded-full ml-2 ${
                        beneficiary.category === 'Pregnant'
                          ? 'bg-pink-100 text-pink-800'
                          : beneficiary.category === 'Child'
                          ? 'bg-blue-100 text-blue-800'
                          : 'bg-purple-100 text-purple-800'
                      }`}
                    >
                      {beneficiary.category}
                    </span>
                  </div>
                  <div
                    className={`beneficiary-status ${
                      beneficiary.status === 'Present' ? 'text-green-600' : 'text-red-600'
                    }`}
                  >
                    {beneficiary.status}
                  </div>
                </div>
                <div className="beneficiary-details text-gray-600 mb-2">
                  Placeholder details for {beneficiary.name}
                </div>
                {beneficiary.status === 'Absent' && (
                  <div className="beneficiary-details text-red-600 flex items-center mb-2">
                    <span className="material-icons mr-1 text-sm">info</span>
                    Not present at VHND. Home visit required.
                  </div>
                )}
                <table className="service-table w-full border-collapse">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="p-2 text-left">Due Service</th>
                      <th className="p-2 text-left">Status</th>
                      <th className="p-2 text-left">Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {beneficiary.services.map((service) => (
                      <tr key={service.id}>
                        <td className="p-2">{service.details}</td>
                        <td className="p-2">
                          <input
                            type="checkbox"
                            checked={service.completed}
                            onChange={(e) =>
                              handleServiceChange(beneficiary.id, service.id, 'completed', e.target.checked)
                            }
                          />
                        </td>
                        <td className="p-2">
                          <input
                            type="text"
                            className="w-full border rounded px-2 py-1"
                            value={service.notes}
                            onChange={(e) =>
                              handleServiceChange(beneficiary.id, service.id, 'notes', e.target.value)
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="service-actions flex space-x-2 mt-2">
                  <button className="service-button flex items-center bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700">
                    <span className="material-icons mr-1">add</span>
                    Add Service
                  </button>
                  {beneficiary.status === 'Present' && (
                    <button className="service-button flex items-center bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700">
                      <span className="material-icons mr-1">medical_services</span>
                      Create Referral
                    </button>
                  )}
                  {beneficiary.status === 'Absent' && (
                    <button className="service-button flex items-center bg-yellow-600 text-white px-3 py-1 rounded hover:bg-yellow-700">
                      <span className="material-icons mr-1">home</span>
                      Schedule Home Visit
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="divider border-t my-4"></div>

        <div className="form-section mb-6">
          <div className="section-title text-lg font-semibold mb-4">Services Provided Summary</div>
          <div className="form-row grid grid-cols-2 gap-4 mb-4">
            <div className="form-field">
              <label className="label block text-gray-600 mb-1">Total Services Provided</label>
              <input
                type="number"
                className="input-field w-full border rounded px-3 py-2"
                value={beneficiaries.reduce((sum, b) => sum + b.services.filter((s) => s.completed).length, 0)}
                readOnly
              />
            </div>
            <div className="form-field">
              <label className="label block text-gray-600 mb-1">Total Beneficiaries Attended</label>
              <input
                type="number"
                className="input-field w-full border rounded px-3 py-2"
                value={beneficiaries.filter((b) => b.status === 'Present').length}
                readOnly
              />
            </div>
          </div>
          {/* Add other summary fields as needed */}
        </div>

        <div className="divider border-t my-4"></div>

        <div className="form-section mb-6">
          <div className="section-title text-lg font-semibold mb-4">Photo Documentation</div>
          <div className="photo-grid grid grid-cols-3 gap-4">
            <div className="photo-item bg-gray-100 p-4 rounded-lg flex flex-col items-center">
              <span className="material-icons text-gray-400 text-4xl">image</span>
              <div className="photo-actions mt-2">
                <span className="material-icons text-red-600 text-sm">delete</span>
              </div>
            </div>
            <div className="add-photo bg-gray-100 p-4 rounded-lg flex flex-col items-center justify-center cursor-pointer hover:bg-gray-200">
              <span className="material-icons text-blue-600 text-4xl">add_a_photo</span>
              <span className="add-text text-blue-600">Add Photo</span>
            </div>
          </div>
        </div>

        <div className="divider border-t my-4"></div>

        <div className="form-section mb-6">
          <div className="section-title text-lg font-semibold mb-4">Issues & Follow-up</div>
          <div className="form-field mb-4">
            <label className="label block text-gray-600 mb-1">Issues Encountered</label>
            <textarea
              className="text-area w-full border rounded px-3 py-2"
              defaultValue={vhndData.notes}
              onChange={(e) => setVhndData({ ...vhndData, notes: e.target.value })}
            ></textarea>
          </div>
          <div className="form-field">
            <label className="label block text-gray-600 mb-1">Follow-up Actions</label>
            <textarea
              className="text-area w-full border rounded px-3 py-2"
              defaultValue=""
              onChange={(e) => setVhndData({ ...vhndData, followUp: e.target.value })}
            ></textarea>
          </div>
        </div>

        <div className="action-buttons flex justify-end space-x-2">
          <button className="cancel-button bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700">
            Cancel
          </button>
          <button
            className="save-button flex items-center bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            onClick={() => saveChanges(beneficiaries)}
          >
            <span className="material-icons mr-1">save</span>
            Save Record
          </button>
        </div>
      </div>
    </>
  );
};

export default VHNDParticipation;  
